const API_MODE = process.env.REACT_APP_API_MODE ?? "real";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

console.log("API_BASE(from cases.js):", API_BASE);
console.log("API_MODE(from cases.js):", API_MODE);

// ① case作成（Wizard開始）
export async function createCase() {
  const url = `${API_BASE}/cases`;
  console.log("createCase url:", url);

  // ✅ ここを追加
  if (API_MODE === "mock") {
    console.warn("⚠️ createCase MOCK");
    return { case_id: "mock-" + Date.now() };
  }

  const res = await fetch(url, { method: "POST" });
  if (!res.ok) {
    throw new Error(`Failed to create case: ${res.status}`);
  }
  return res.json(); // { case_id }
}

// ② answers上書き保存
export async function saveCase(caseId, answers) {
  if (!caseId) return; // 保険

  // ✅ ここを追加
  if (API_MODE === "mock") {
    console.warn("⚠️ saveCase MOCK", { caseId, answers });
    return { ok: true };
  }

  const url = `${API_BASE}/cases/${caseId}`;
  const res = await fetch(url, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ answers }),
  });

  if (!res.ok) {
    throw new Error(`Failed to save case: ${res.status}`);
  }
  return res.json();
}

// ③ submit（完了）
export async function submitCase(caseId, proposedCameraCount = 0) {
  if (!caseId) return; // 保険

  const safeProposedCameraCount = Number.isFinite(Number(proposedCameraCount))
    ? Number(proposedCameraCount)
    : 0;

  // ✅ ここを追加
  if (API_MODE === "mock") {
    console.warn("⚠️ submitCase MOCK", {
      caseId,
      proposed_camera_count: safeProposedCameraCount,
    });
    return {
      submitted_at: new Date().toISOString(),
      proposed_camera_count: safeProposedCameraCount,
    };
  }

  const url = `${API_BASE}/cases/${caseId}/submit`;
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      proposed_camera_count: safeProposedCameraCount,
    }),
  });

  if (!res.ok) {
    throw new Error(`Failed to submit case: ${res.status}`);
  }

  return res.json();
}
